import { debugId, toDebugString } from "./debug";
import { EndpointError } from "./types";
import { evaluateRules } from "./utils";
export const resolveEndpoint = (ruleSetObject, options) => {
  var _options$logger, _options$logger$debug, _options$endpointPara, _options$logger2, _options$logger2$debu;
  const {
    endpointParams,
    logger
  } = options;
  const {
    parameters,
    rules
  } = ruleSetObject;
  (_options$logger = options.logger) === null || _options$logger === void 0 || (_options$logger$debug = _options$logger.debug) === null || _options$logger$debug === void 0 || _options$logger$debug.call(_options$logger, "".concat(debugId, " Initial EndpointParams: ").concat(toDebugString(endpointParams)));
  const paramsWithDefault = Object.entries(parameters).filter(_ref => {
    let [, v] = _ref;
    return v.default != null;
  }).map(_ref2 => {
    let [k, v] = _ref2;
    return [k, v.default];
  });
  if (paramsWithDefault.length > 0) {
    for (const [paramKey, paramDefaultValue] of paramsWithDefault) {
      var _endpointParams$param;
      endpointParams[paramKey] = (_endpointParams$param = endpointParams[paramKey]) !== null && _endpointParams$param !== void 0 ? _endpointParams$param : paramDefaultValue;
    }
  }
  const requiredParams = Object.entries(parameters).filter(_ref3 => {
    let [, v] = _ref3;
    return v.required;
  }).map(_ref4 => {
    let [k] = _ref4;
    return k;
  });
  for (const requiredParam of requiredParams) {
    if (endpointParams[requiredParam] == null) {
      throw new EndpointError("Missing required parameter: '".concat(requiredParam, "'"));
    }
  }
  const endpoint = evaluateRules(rules, {
    endpointParams,
    logger,
    referenceRecord: {}
  });
  if ((_options$endpointPara = options.endpointParams) !== null && _options$endpointPara !== void 0 && _options$endpointPara.Endpoint) {
    try {
      const givenEndpoint = new URL(options.endpointParams.Endpoint);
      const {
        protocol,
        port
      } = givenEndpoint;
      endpoint.url.protocol = protocol;
      endpoint.url.port = port;
    } catch (e) {}
  }
  (_options$logger2 = options.logger) === null || _options$logger2 === void 0 || (_options$logger2$debu = _options$logger2.debug) === null || _options$logger2$debu === void 0 || _options$logger2$debu.call(_options$logger2, "".concat(debugId, " Resolved endpoint: ").concat(toDebugString(endpoint)));
  return endpoint;
};